import { Component, Renderer2 } from '@angular/core'
import { TranslateService } from '@app/shared/services/translate'
import locales from './locales'
import { NavigationStart, Router } from '@angular/router'
import { Subject, filter, takeUntil } from 'rxjs'

@Component({
  selector: 'sidebar-mobile-button',
  templateUrl: './sidebar-mobile-button.component.html',
  standalone: false,
})
export class SidebarMobileButtonComponent {
  constructor(
    private translate: TranslateService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  t = this.translate.create(locales)

  destroy$ = new Subject<void>()

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        this.renderer.removeClass(document.body, 'body-navbar--show')
      })
  }

  toggle(): void {
    if (document.body.classList.contains('body-navbar--show')) {
      this.renderer.removeClass(document.body, 'body-navbar--show')
    } else {
      this.renderer.addClass(document.body, 'body-navbar--show')
    }
  }
}
